import { RightOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import { getMyLeaveSummary } from '../../../../api/aopsHR.api'
import AopsBox from '../../../../components/apos/AopsBox'
import SectionHeader from '../../../../components/apos/SectionHeader'
import { userState } from '../../../../store/user'
import {
  formatLeave,
  returnMonthToYear,
} from '../../../../utils/calcuateAnnualLeave'
import '../myHrManage.scss'

const AnnualLeaveSection = () => {
  const navigate = useNavigate()
  const [user] = useRecoilState(userState)
  const [leaveData, setLeaveData] = useState(null)

  useEffect(() => {
    const getMyLeaveSummaryData = async () => {
      try {
        const response = await getMyLeaveSummary(user?.id)
        // console.log('getMyLeaveSummaryData response::', response)
        setLeaveData(response.data)
      } catch (error) {
        console.error('error::', error)
      }
    }

    if (user?.id) {
      getMyLeaveSummaryData()
    }
  }, [user])

  const {
    userName = '',
    studioName = '',
    teamName = '',
    hiredDate = '',
    tenureYear = 1,
    totalDays = 0,
    usedDays = 0,
    remainedDays = 0,
    validStartDate = '',
    validEndDate = '',
  } = leaveData || {}

  const formattedJoinDate = hiredDate
    ? dayjs(hiredDate).format('YY년 MM/DD')
    : '--년 --/--'

  const formattedTenure = returnMonthToYear(tenureYear || 0)

  // 상단 연차 통계 데이터

  const leaveStats = [
    {
      label: '총 발생 연차',
      value: formatLeave(totalDays),
    },
    {
      label: '사용 연차(승인)',
      value: formatLeave(usedDays),
    },
    {
      label: '잔여 연차',
      value: formatLeave(remainedDays),
    },
  ]

  // 하단 연차 날짜 데이터
  const leaveDates = [
    {
      label: '연차 갱신일',
      value: validStartDate
        ? dayjs(validStartDate).format('YY.MM.DD')
        : '--. --. --',
    },
    {
      label: '연차 만료일',
      value: validEndDate
        ? dayjs(validEndDate).format('YY.MM.DD')
        : '--. --. --',
    },
  ]

  return (
    <div className="annual-leave-section">
      <SectionHeader
        title="내 연차 내역"
        subtitle="내 연차 현황 이력을 살펴볼 수 있어요"
      />
      <AopsBox
        style={{
          padding: '24px',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
        borderBottom={true}
        title="내 연차 내역"
        button={
          <>
            <span>더보기</span>
            <RightOutlined style={{ fontSize: '16px', color: '#8C979D' }} />
          </>
        }
        onButtonClick={() => navigate(`/hr/annual-leave/${user?.id}`)}
      >
        <div className="annual-leave-content">
          {/* 왼쪽: 직원 정보 */}
          <div className="annual-leave-employee-info">
            <div className="annual-leave-employee-name">{userName}</div>
            <div className="annual-leave-employee-details">
              {studioName} 스튜디오
              <span className="annual-leave-divider">|</span>
              {teamName}
            </div>
            <div className="annual-leave-badge">
              {formattedTenure} · {formattedJoinDate} 입사
            </div>
          </div>

          {/* 오른쪽: 연차 통계 */}
          <div className="annual-leave-stats-container">
            {/* 상단 행: 연차 통계 */}
            <div className="annual-leave-stats-row">
              {leaveStats.map((stat, index) => (
                <div key={index} className="annual-leave-stat-item">
                  <div className="annual-leave-stat-label">{stat.label}</div>
                  <div className="annual-leave-stat-value">{stat.value}</div>
                </div>
              ))}
            </div>

            {/* 하단 행: 연차 날짜 */}
            <div className="annual-leave-dates-row">
              {leaveDates.map((date, index) => (
                <div key={index} className="annual-leave-date-item">
                  <div className="annual-leave-date-label">{date.label}</div>
                  <div className="annual-leave-date-value">{date.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </AopsBox>
    </div>
  )
}

export default AnnualLeaveSection
